import axiosInstance from '../axiosInstance';
import Auth from '../modules/auth';

export const sendClaim = async claim => {
  axiosInstance.post('/claims', claim);
}

export const getAllClaims = async () => {
  try {
    var token = await Auth.getToken();

 
    const claims = await axiosInstance.get('/claims',{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return claims.data.map(claim => {
      return {
        id: claim._id,
        active: claim.active,
        created: claim.created,
        reasonClose: claim.reasonClose,
        description: claim.description,
        maternity: claim.maternity,
        county: claim.county,
        name: `${claim.contact.firstName} ${claim.contact.lastName}`,
        email: claim.contact.email,
        phone: claim.contact.phone,
        rank: claim.rank,
        type: claim.type,
        resolved: claim.resolved,
        resolvedDate: claim.resolvedDate
      };
    });
  } catch (error) {
    console.error(error);
  }
};


export const getAllClaimsActiveCnt = async () => {
  try {
    const claims = await axiosInstance.get('/claims/cntActive');
    //console.log(claims);
    return claims.data.cnt;
  } catch (error) {
    
    //console.error(error);
    return 0;
  }
};

export const resolveClaim = async claimId => {
  try {
    var token = await Auth.getToken();
    await axiosInstance.put(`/claims/${claimId}`, { resolved: true, resolvedDate: new Date() },{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
  } catch (error) {
    //console.log(error);
  }
};
export const deleteClaim = async (claimId, reason) => {
  try {
    var token = await Auth.getToken();
    await axiosInstance.put(`/claims/${claimId}`, { active: false, reasonClose:reason },{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
  } catch (error) {
    //console.log(error);
  }
};